/** @jsx jsx */
import { Icon } from "@blueprintjs/core";
import { css, jsx } from "@emotion/react";
import LegendPopOver from "./LegendPopOver";

/**
 * A title for the legend that displays a popup of all the
 * items when it's icon is hovered over
 */
export default function LegendTitle({legendItemProps}) {
    return (
        <div className="legendTitle show-on-card-hover"
             css={legendTitleCss}>
            <LegendPopOver legendItemProps={legendItemProps}>
                <Icon icon="map" 
                    iconSize={20}
                    color={ICON_COLOR}/>
            </LegendPopOver>
        </div>
    )
}

const ICON_COLOR = "#6699CC"

const legendTitleCss = css`
    .bp3-icon {
        color:${ICON_COLOR}
    }
    flex-direction: row;
    display: flex;
`
